import{parseVersion}from'soapbox/utils/features';import{useInstance}from'./useInstance';/**
 * Get the Backend version.
 *
 * @returns Backend
 */var useBackend=function useBackend(){var instance=useInstance();return parseVersion(instance.version);};export{useBackend};